import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { categoryAPI } from '../../services/categoryAPI';

interface CategoryState {
  categories: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: CategoryState = {
  categories: [],
  isLoading: false,
  error: null,
};

export const fetchCategories = createAsyncThunk('categories/fetchCategories', async () => {
  console.log('API call: fetchCategories');
  const result = await categoryAPI.getAllCategories();
  console.log('API response:', result);
  return result;
});

export const createCategory = createAsyncThunk('categories/createCategory', async (data: FormData) => {
  return await categoryAPI.createCategory(data);
});

export const updateCategory = createAsyncThunk('categories/updateCategory', async ({ id, data }: { id: string; data: FormData }) => {
  return await categoryAPI.updateCategory(id, data);
});

export const deleteCategory = createAsyncThunk('categories/deleteCategory', async (id: string) => {
  await categoryAPI.deleteCategory(id);
  return id;
});

const categorySlice = createSlice({
  name: 'categories',
  initialState,
  reducers: { clearError: (state) => { state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        console.log('fetchCategories pending');
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        console.log('Raw API response:', action.payload);
        // Handle different response structures
        if (action.payload.categories) {
          state.categories = action.payload.categories;
        } else if (action.payload.data) {
          state.categories = action.payload.data;
        } else if (Array.isArray(action.payload)) {
          state.categories = action.payload;
        } else {
          state.categories = [];
        }
        state.isLoading = false;
        console.log('Categories set to:', state.categories);
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch categories';
        console.log('fetchCategories rejected:', action.error);
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        console.log('Create category response:', action.payload);
        const newCategory = action.payload.category || action.payload.data || action.payload;
        state.categories.unshift(newCategory);
        console.log('Categories after create:', state.categories);
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        console.log('Update category response:', action.payload);
        const updatedCategory = action.payload.category || action.payload.data || action.payload;
        const index = state.categories.findIndex(c => c._id === updatedCategory._id);
        if (index !== -1) {
          state.categories[index] = updatedCategory;
        }
        console.log('Categories after update:', state.categories);
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.categories = state.categories.filter(c => c._id !== action.payload);
      });
  },
});

export default categorySlice.reducer;